import { AuthUserPermission } from '@cibo/core'
import { AgreementStatus } from './types'
import { Can } from '@cibo/profile'
import { useAgreement } from './queries'
import { Button } from '@mui/material'
import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

// TT doesn't want this feature (eye roll), but its useful for debugging & I suspect it'll come back
export const AgreementResetButton = ({
  agreementId,
  ownsAgreement,
  setActionModal,
}: {
  agreementId: string
  ownsAgreement?: boolean
  setActionModal: Dispatch<SetStateAction<{ open: boolean; action?: AgreementStatus }>>
}) => {
  const { t } = useTranslation('impact/pages/Agreements')
  const agreement = useAgreement(agreementId)
  return (
    <Can useAny={AuthUserPermission.DEBUG_USER}>
      {agreement.data?.isAllowed('can_agree') &&
        !ownsAgreement &&
        agreement.data?.status !== 'agreed' && (
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => setActionModal({ open: true, action: 'pending' })}
            disabled={agreement.data?.status === 'pending'}
          >
            {t('pendingButton')}
          </Button>
        )}
    </Can>
  )
}
